"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRoutesComponent = createRoutesComponent;
// Same as react-router-dom Routes but with our useRoutes instead of the original one
// https://github.com/remix-run/react-router/blob/5d66dbdbc8edf1d9c3a4d9c9d84073d046b5785b/packages/react-router/lib/components.tsx#L503-L508
function createRoutesComponent(useRoutes, createRoutesFromChildren) {
    return function Routes({ children, location }) {
        return useRoutes(createRoutesFromChildren(children), location);
    };
}
//# sourceMappingURL=routesComponent.js.map